import React, { useEffect, useState } from "react";
import { Global } from "../helpers/Global";

export const InterProcesoGerente = () => {
    const [ticajes, setTicajes] = useState([]);
    const [mensaje, setMensaje] = useState("");

    useEffect(() => {
        const fetchTicajes = async () => {
            try {
                const res = await fetch(Global.url + "ticajes/proceso", {
                    headers: {
                        Authorization: `Bearer ${localStorage.getItem("token")}`,
                    },
                });
                if (res.ok) {
                    const data = await res.json();
                    setTicajes(data);
                } else {
                    setMensaje("No se pudieron obtener los ticajes en proceso.");
                }
            } catch (error) {
                console.error("Error al cargar los ticajes:", error);
                setMensaje("Error de conexión con el servidor.");
            }
        };

        fetchTicajes();
    }, []);

    return (
        <div className="consulta-ticajes">
            <h2 className="centrar-titulo">Ticajes en Proceso</h2>
            {mensaje && <p className="rojo">{mensaje}</p>}

            {ticajes.length === 0 ? (
                <p>No hay ticajes activos de tu equipo.</p>
            ) : (
                <div className="table-listado-padre">
                    <table className="table-listado">
                        <thead>
                            <tr>
                                <th>Usuario</th>
                                <th>Cliente</th>
                                <th>Centro</th>
                                <th>Inicio</th>
                                <th>Comentarios</th>
                            </tr>
                        </thead>
                        <tbody>
                            {ticajes.map((t) => (
                                <tr key={t.id}>
                                    <td>{t.usuario}</td>
                                    <td>{t.cliente}</td>
                                    <td>{t.centro}</td>
                                    <td>{new Date(t.inicio).toLocaleString()}</td>
                                    <td>{t.comentarios || "Sin comentarios"}</td>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </div>
    );
};
